<template>
  <div v-loading="loading" class="new-order-info">
    <div class="title">最新订单</div>
    <div class="content">
      <table style="table-layout: fixed;">
        <tr>
          <td width="160px">订单编号</td>
          <td width="120px">客户</td>
          <td width="100px">品牌</td>
          <td width="100px">金额</td>
          <td width="100px">状态</td>
        </tr>
        <template v-if="context && context.length">
          <tr v-for="row in context.slice(0, 7)" :key="row.area">
            <td>
              <a :href="`/order/detail/${row.id}`">{{ row.orderSn }}</a>
            </td>
            <td>
              <ellipsis-text :content="`${row.userName}/${ row.buyerName }`">{{ row.userName }}/{{ row.buyerName }}</ellipsis-text>
            </td>
            <td>{{ row.brandNames }}</td>
            <td>{{ row.amountPay }}</td>
            <td>{{ stateFmt(row.state) }}</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="6" class="no-data">暂无数据</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import { loadLastestOrderInfo } from '../services'
export default {
  name: 'DayOrderInfo',
  data () {
    return {
      loading: true,
      context: []
    }
  },
  methods: {
    loadData () {
      this.loading = true
      loadLastestOrderInfo(this.area).then((resp) => {
        this.context = resp
      }).finally(() => {
        this.loading = false
      })
    },
    stateFmt (orderState) {
      return this.$store.state.orderState.find(t => t.id === orderState).name
    }
  },
  beforeMount () {
    this.loadData()
  },
  watch: {
    area () {
      this.loadData()
    }
  }
}
</script>
